/**
 * Carte Leaflet du bottin entrepreneurs — marqueurs chargés via AJAX.
 * Build : entrée Webpack `js/entrepreneur-map` → themes/.../assets/js/entrepreneur-map.js
 * Ne pas éditer le fichier minifié dans assets/ ; modifier ce fichier puis `npm run build`.
 */
import iconPinOrange from '../images/icon-pin-orange.svg';
import iconPinGray from '../images/icon-pin-gray.svg';

(function () {
    'use strict';

    var cfg = window.CCEntrepreneurMapConfig;
    if (!cfg || typeof L === 'undefined') {
        return;
    }

    var el = document.getElementById('cc-entrepreneur-map');
    if (!el) {
        return;
    }

    var W = 33;
    var H = 40;

    function makePinIcon(url, w, h, hoverClass) {
        var ax = Math.round(w / 2);
        var opts = {
            iconUrl: url,
            iconSize: [w, h],
            iconAnchor: [ax, h],
            popupAnchor: [0, -h + 8],
        };
        if (hoverClass) {
            opts.className = hoverClass;
        }
        return L.icon(opts);
    }

    var iconPremium = makePinIcon(iconPinOrange, W, H);
    var iconLimited = makePinIcon(iconPinGray, W, H, 'cc-map-marker--limited');

    var HOVER_SCALE = 1.25;
    var hiW = Math.round(W * HOVER_SCALE);
    var hiH = Math.round(H * HOVER_SCALE);

    var center = cfg.defaultCenter || [46.8139, -71.2082];
    var zoom = typeof cfg.defaultZoom === 'number' ? cfg.defaultZoom : 7;

    var map = L.map(el, { scrollWheelZoom: true }).setView(center, zoom);

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
    }).addTo(map);

    function attachBottinMapScrollFix(mapInstance) {
        var layout = document.querySelector('.cc-entrepreneur-layout');
        var column = document.querySelector('.cc-entrepreneur-map-column');
        var mapWrap = document.querySelector('.cc-entrepreneur-map-wrap');
        if (!layout || !column || !mapWrap || !mapInstance) {
            return;
        }

        var mq = window.matchMedia('(min-width: 992px)');
        var rafId = null;
        var lastMode = '';

        function pinnedTopPx() {
            var base = 24;
            if (!document.body.classList.contains('admin-bar')) {
                return base;
            }
            return window.innerWidth <= 782 ? base + 46 : base + 32;
        }

        function getListContentHeight(listEl) {
            if (!listEl) {
                return 0;
            }
            var style = window.getComputedStyle(listEl);
            var total = (parseFloat(style.paddingTop) || 0) + (parseFloat(style.paddingBottom) || 0);
            var gap = parseFloat(style.rowGap) || parseFloat(style.gap) || 0;
            var children = listEl.children;
            for (var i = 0; i < children.length; i++) {
                if (i > 0) {
                    total += gap;
                }
                total += children[i].getBoundingClientRect().height;
            }
            return total;
        }

        function clearMapPosition() {
            mapWrap.classList.remove('cc-map--fixed-scroll', 'cc-map--fixed-end');
            ['position', 'top', 'left', 'right', 'bottom', 'width'].forEach(function (p) {
                mapWrap.style.removeProperty(p);
            });
            column.style.removeProperty('min-height');
        }

        function update() {
            rafId = null;

            if (!mq.matches) {
                clearMapPosition();
                if (lastMode !== 'off') {
                    lastMode = 'off';
                    mapInstance.invalidateSize();
                }
                return;
            }

            var tg = pinnedTopPx();
            var layoutRect = layout.getBoundingClientRect();
            var wrapH = mapWrap.offsetHeight;
            var listEl = layout.querySelector('.cc-entrepreneur-list');
            var listContentH = getListContentHeight(listEl);
            if (listContentH <= wrapH + 8) {
                clearMapPosition();
                if (lastMode !== 'short') {
                    lastMode = 'short';
                    mapInstance.invalidateSize();
                }
                return;
            }

            /* Référencer la colonne (toujours dans le flux), pas le wrap : en fixed, wrapRect.top reste ~tg et ne repasse jamais > tg au scroll vers le haut. */
            var colTop = column.getBoundingClientRect().top;
            var room = layoutRect.bottom - tg;
            var pinBottom = room < wrapH;
            var mode;

            if (colTop > tg) {
                mode = 'flow';
            } else if (pinBottom) {
                mode = 'bottom';
            } else {
                mode = 'fixed';
            }

            var prevMode = lastMode;
            lastMode = mode;

            if (mode === 'flow') {
                clearMapPosition();
            } else if (mode === 'bottom') {
                mapWrap.classList.remove('cc-map--fixed-scroll');
                mapWrap.classList.add('cc-map--fixed-end');
                ['position', 'top', 'left', 'width', 'right', 'bottom'].forEach(function (p) {
                    mapWrap.style.removeProperty(p);
                });
                column.style.minHeight = wrapH + 'px';
            } else {
                var colRect = column.getBoundingClientRect();
                var colW = column.offsetWidth;
                mapWrap.classList.remove('cc-map--fixed-end');
                mapWrap.classList.add('cc-map--fixed-scroll');
                mapWrap.style.position = 'fixed';
                mapWrap.style.top = tg + 'px';
                mapWrap.style.left = colRect.left + 'px';
                mapWrap.style.width = colW + 'px';
                mapWrap.style.right = '';
                mapWrap.style.bottom = '';
                column.style.minHeight = wrapH + 'px';
            }

            if (prevMode !== mode) {
                requestAnimationFrame(function () {
                    mapInstance.invalidateSize();
                });
            }
        }

        function schedule() {
            if (rafId != null) {
                return;
            }
            rafId = requestAnimationFrame(update);
        }

        window.addEventListener('scroll', schedule, { passive: true });
        window.addEventListener('resize', function () {
            schedule();
            requestAnimationFrame(function () {
                mapInstance.invalidateSize();
            });
        });
        if (typeof mq.addEventListener === 'function') {
            mq.addEventListener('change', schedule);
        } else if (typeof mq.addListener === 'function') {
            mq.addListener(schedule);
        }
        schedule();
    }

    attachBottinMapScrollFix(map);

    function escapeHtml(text) {
        var d = document.createElement('div');
        d.textContent = text == null ? '' : String(text);
        return d.innerHTML;
    }

    function buildPopupHtml(m) {
        var s = cfg.strings || {};
        var name = escapeHtml(m.name || '');
        var isPremium = !!m.is_premium;
        var badgeText = isPremium
            ? (s.badgePremium || 'Qualifié • RBQ Vérifié')
            : (s.badgeLimited || 'Profil limité');
        var badgeClass = isPremium ? 'cc-popup__badge cc-popup__badge--premium' : 'cc-popup__badge cc-popup__badge--limited';
        var badge = '<span class="' + badgeClass + '">' + escapeHtml(badgeText) + '</span>';

        var cityBlock = '';
        var city = m.city != null ? String(m.city).trim() : '';
        if (city !== '') {
            cityBlock = '<p class="cc-popup__city">' + escapeHtml(city) + '</p>';
        }

        var workBlock = '';
        var wtAll = Array.isArray(m.work_types) ? m.work_types.filter(Boolean) : [];
        if (wtAll.length) {
            var wtShow = wtAll.slice(0, 5);
            var wtLine = wtShow.map(function (x) {
                return escapeHtml(x);
            }).join(' • ');
            if (wtAll.length > 5) {
                wtLine += ' • ' + escapeHtml(s.workTypesMore || 'Et plus.');
            }
            workBlock = '<p class="cc-popup__work-types">' + wtLine + '</p>';
        }

        var linkParts = [];
        if (m.action_form) {
            linkParts.push(m.action_form);
        } else if (m.request_url) {
            linkParts.push(
                '<a class="white-button orange-button" href="' + escapeHtml(m.request_url) + '">' +
                escapeHtml(s.requestQuote || 'Demander une soumission') +
                '</a>'
            );
        }
        if (m.fiche_url) {
            linkParts.push(
                '<a class="white-button orange-button orange-button--user" href="' + escapeHtml(m.fiche_url) + '">' +
                escapeHtml(s.viewProfile || 'Voir le profil') +
                '</a>'
            );
        }
        var links = linkParts.length ? '<div class="cc-popup__actions">' + linkParts.join('') + '</div>' : '';

        return (
            '<div class="cc-popup">' +
            '<p class="cc-popup__badge-wrap">' + badge + '</p>' +
            '<p class="cc-popup__title"><strong>' + name + '</strong></p>' +
            cityBlock +
            workBlock +
            links +
            '</div>'
        );
    }

    function loadMarkers() {
        var ids = el.getAttribute('data-entrepreneur-ids') || '';
        var selectProject = el.getAttribute('data-select-for-project') || '0';

        var formData = new FormData();
        formData.append('action', cfg.action);
        formData.append('nonce', cfg.nonce);
        formData.append('ids', ids);
        formData.append('select_for_project', selectProject);
        formData.append('redirect_to', window.location.href);

        fetch(cfg.ajaxUrl, {
            method: 'POST',
            body: formData,
            credentials: 'same-origin',
        })
            .then(function (r) {
                return r.json();
            })
            .then(function (json) {
                if (!json || !json.success || !json.data || !Array.isArray(json.data.markers)) {
                    return;
                }

                var markers = json.data.markers;
                var group = L.featureGroup();
                var markersById = {};

                markers.forEach(function (m) {
                    var lat = parseFloat(m.map_lat);
                    var lng = parseFloat(m.map_lng);
                    if (!isFinite(lat) || !isFinite(lng)) {
                        return;
                    }

                    var isPremium = !!m.is_premium;
                    var pinUrl = isPremium ? iconPinOrange : iconPinGray;
                    var iconNormal = isPremium ? iconPremium : iconLimited;
                    var marker = L.marker([lat, lng], {
                        icon: iconNormal,
                    });

                    marker._ccIconNormal = iconNormal;
                    var hoverCls = isPremium
                        ? 'cc-map-marker--highlight'
                        : 'cc-map-marker--limited cc-map-marker--highlight';
                    marker._ccIconHover = makePinIcon(pinUrl, hiW, hiH, hoverCls);

                    if (isPremium) {
                        marker.bindPopup(buildPopupHtml(m), { className: 'cc-map-popup' });
                    }
                    marker.addTo(group);

                    var uid = parseInt(m.id, 10);
                    if (uid > 0) {
                        markersById[uid] = marker;
                    }
                });

                group.addTo(map);

                function setMarkerHighlight(userId, on) {
                    var mk = markersById[userId];
                    if (!mk || !mk._ccIconNormal || !mk._ccIconHover) {
                        return;
                    }
                    if (typeof mk.setIcon === 'function') {
                        mk.setIcon(on ? mk._ccIconHover : mk._ccIconNormal);
                    }
                    if (typeof mk.setZIndexOffset === 'function') {
                        mk.setZIndexOffset(on ? 650 : 0);
                    }
                }

                document.querySelectorAll('.cc-entrepreneur-card[data-entrepreneur-id]').forEach(function (card) {
                    var rawId = card.getAttribute('data-entrepreneur-id');
                    var userId = parseInt(rawId, 10);
                    if (!userId || !markersById[userId]) {
                        return;
                    }
                    card.addEventListener('mouseenter', function () {
                        setMarkerHighlight(userId, true);
                    });
                    card.addEventListener('mouseleave', function () {
                        setMarkerHighlight(userId, false);
                    });
                });

                var layers = group.getLayers();
                if (layers.length === 1) {
                    map.setView(layers[0].getLatLng(), Math.max(zoom, 12));
                } else if (layers.length > 1) {
                    try {
                        map.fitBounds(group.getBounds().pad(0.15));
                    } catch (e) {
                        /* ignore */
                    }
                }

                setTimeout(function () {
                    map.invalidateSize();
                }, 100);
            })
            .catch(function () {
                /* ignore */
            });
    }

    loadMarkers();

    (function initBottinBackToListTop() {
        var btn = document.querySelector('.js-cc-bottin-back-to-list');
        var target = document.getElementById('cc-bottin-listing-top');
        if (!btn || !target) {
            return;
        }

        btn.removeAttribute('hidden');

        var rafVis = null;
        var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        function setVisible(show) {
            btn.classList.toggle('is-visible', show);
            btn.setAttribute('aria-hidden', show ? 'false' : 'true');
            if (show) {
                btn.removeAttribute('tabindex');
            } else {
                btn.setAttribute('tabindex', '-1');
            }
        }

        function updateVisibility() {
            rafVis = null;
            var r = target.getBoundingClientRect();
            /* Uniquement tant qu’on est « dans » la section : haut dépassé, bas pas encore sorti par le bas */
            var scrolledIntoSection = r.top < 0;
            var stillInSection = r.bottom > 0;
            setVisible(scrolledIntoSection && stillInSection);
        }

        function scheduleVis() {
            if (rafVis != null) {
                return;
            }
            rafVis = requestAnimationFrame(updateVisibility);
        }

        btn.addEventListener('click', function () {
            var instant = reduceMotion.matches;
            target.scrollIntoView({ behavior: instant ? 'auto' : 'smooth', block: 'start' });
            if (typeof target.focus === 'function') {
                try {
                    target.focus({ preventScroll: true });
                } catch (e) {
                    target.focus();
                }
            }
        });

        window.addEventListener('scroll', scheduleVis, { passive: true });
        window.addEventListener('resize', scheduleVis);
        if (typeof reduceMotion.addEventListener === 'function') {
            reduceMotion.addEventListener('change', scheduleVis);
        } else if (typeof reduceMotion.addListener === 'function') {
            reduceMotion.addListener(scheduleVis);
        }
        scheduleVis();
    })();
})();
